import { isEqual } from 'lodash';

/** Structural mirror of @mes-amis/super-form's ChangeMeta (>= 1.2.14).
 *  Older package builds call onChange without it, which counts as a user edit. */
export interface FormChangeMeta {
  source?: 'user' | 'engine';
}

/**
 * Decide whether a store onChange call represents a USER edit — the only kind
 * that may mark the document dirty (dirty blocks applying live WebSocket
 * updates to the open editor until the pending save clears it).
 *
 * Not user edits:
 * - engine-driven writes: super-form's mount backfill of blank formula/case
 *   fields, cascade recomputes, depends_on clearing, need-score totals. These
 *   fire with zero interaction; marking dirty for them wedges the flag forever
 *   because saves are blur-driven and no blur ever comes.
 * - echoes of a just-applied server snapshot: applying server data makes
 *   SuperForm re-fire onChange with the same values a tick later.
 */
export function isUserEdit(
  meta: FormChangeMeta | undefined,
  appliedServer: Record<string, unknown> | null,
  fieldName: string,
  value: unknown,
): boolean {
  if (meta?.source === 'engine') return false;
  if (appliedServer != null && fieldName in appliedServer && isEqual(appliedServer[fieldName], value)) return false;
  return true;
}
